import { render, staticRenderFns } from "./OnboardingConsumerPrivacyNotice.vue?vue&type=template&id=65e5e5ce&"
import script from "./OnboardingConsumerPrivacyNotice.vue?vue&type=script&lang=js&"
export * from "./OnboardingConsumerPrivacyNotice.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingConsumerPrivacyNotice.vue?vue&type=style&index=0&id=65e5e5ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports